<template>
  <div class="flex flex-col gap-4" :class="errorShow ? 'error' : ''">
    <div class="flex justify-between sm:justify-start sm:gap-12">
      <label
        v-for="option in options"
        :key="option.id"
        class="input-radio-image-wrapp relative flex flex-col items-center w-32 pt-6 pb-4 px-8 text-center text-base text-blue cursor-pointer select-none"
      >
        <input
          type="radio"
          :name="name"
          class="absolute left-[-99999px] opacity-0 peer"
          :checked="option.id === value"
          @change="$emit('input', option.id)"
        />

        <img
          class="relative z-10 h-[50px] select-none pointer-events-none"
          :src="option.img"
          :alt="option.text"
        />

        <span
          class="input-radio-image-check peer-checked:scale-100 peer-checked:opacity-100 flex items-center justify-center absolute -top-1 -right-1 w-6 h-6 bg-blue rounded-full scale-50 opacity-0 duration-200 z-10"
        >
          <svg class="w-4" viewBox="0 0 16 16" fill="none">
            <path d="M2.5 7.75L6.5 11.75L14.25 4" stroke="white" />
          </svg>
        </span>

        <span
          class="input-radio-image-border peer-checked:border-blue absolute inset-0 bg-white input-border pointer-events-none duration-200"
        ></span>

        <span
          class="input-radio-image-text relative z-10 mt-[10px]"
          v-text="option.text"
        ></span>
      </label>
    </div>

    <p v-if="errorShow" class="text-xs text-red">{{ errorText }}</p>
  </div>
</template>

<script>
export default {
  name: 'CalculatorRadioImageButton',
  props: {
    options: {
      type: Array,
      default: [],
    },
    name: String,
    value: String,
    errorShow: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: 'This field is required',
    },
  },
}
</script>
